import {
  BadgeCheck,
  BellRing,
  BookOpenText,
  Building,
  Gauge,
  Rss,
  ScrollText,
  UserCog,
  Users,
} from 'lucide-react'
import type { NavSection } from '../types'

/** Platform admin navigation (M-05). Add an entry here and a route in ./routes.tsx. */
export const adminNav: NavSection[] = [
  {
    items: [{ label: 'Overview', to: '/admin', icon: Gauge, end: true }],
  },
  {
    label: 'Access',
    items: [
      { label: 'Orgs', to: '/admin/orgs', icon: Building },
      { label: 'Users', to: '/admin/users', icon: Users },
      { label: 'Staff', to: '/admin/staff', icon: UserCog },
      { label: 'Subscriptions', to: '/admin/subscriptions', icon: BadgeCheck },
    ],
  },
  {
    label: 'Operations',
    items: [
      { label: 'Data feeds', to: '/admin/feeds', icon: Rss },
      { label: 'Alerts', to: '/admin/alerts', icon: BellRing },
      { label: 'Audit', to: '/admin/audit', icon: ScrollText },
      {
        label: 'Dev docs',
        to: '/admin/dev-docs',
        icon: BookOpenText,
        activeFor: ['/admin/docs'],
        requires: 'platform_operator',
      },
    ],
  },
]
